import { Container, Box } from '@mui/material';
import giftCardWork from '../../assets/99giftimages/StepsNew.jpg.jpeg';

const GiftCardWorking = ({ image = giftCardWork }) => {
    return (
        <Container
            maxWidth="false"
            disableGutters={true}
            sx={{
                mb: 2,
                backgroundColor: 'primary.main',
                border: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                maxWidth="lg"
                sx={{
                    display: 'flex',

                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    component="img"
                    src={image}
                    alt="How Gift Card Works image"
                    loading="lazy"
                    sx={{
                        width: '100%',
                        height: {
                            xs: 'auto',
                            lg: 450,
                        },
                        borderRadius: {
                            xs: 2,
                            lg: 3,
                        },
                    }}
                />
            </Box>
        </Container>
    );
};

export default GiftCardWorking;
